<div class="ui-notify-content">
  <mat-icon class="ui-notify__icon">
    {{icon}}
  </mat-icon>

  <span>{{message}}</span>
</div>
